<template>
    <div class="basket">
        <div @click="toggleDropdown">
            <span class="count" v-if="items.length">{{ items.length }}</span>
            <i class="icon-shopping-cart"></i>
        </div>
        <header-basket-dropdown v-if="items.length && show" :items="items" :src="src"></header-basket-dropdown>
    </div>
</template>

<script>

import HeaderBasketDropdown from './HeaderBasketDropdown.vue'

export default {
  
  components: {
      HeaderBasketDropdown
  },

  props: {
      src: {
          default: '/cart',
          required: false,
          type: String
      }
  },

  data() {
      return {

          items: [],
          show: false

      }
  },

  created() {
      this.fetchData();

      App.dispatcher.listen(
          App.event.CART_UPDATED,
          items => this.items = items
      );
      
  },

  methods: {

      toggleDropdown() {
          this.show = ! this.show
      },

      fetchData() {
          new App.xhr().get(this.src).then(items => this.items = items);
      }

  }

}
</script>
